var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOverallGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166.48311,
    height: 164.68034,
    viewBox: "0 0 166.48311 164.68034",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h125v124h-125z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,1.3333333,0,4.7836754e-6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath22)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#319a7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.453 53.723c-1.433-0.817-3.039-1.227-4.816-1.227-1.778 0-3.383 0.41-4.813 1.227-1.437 0.816-2.562 1.957-3.375 3.418-0.82 1.461-1.226 3.125-1.226 4.988s0.406 3.523 1.226 4.984c0.813 1.461 1.938 2.602 3.375 3.418 1.43 0.817 3.035 1.227 4.813 1.227 1.777 0 3.383-0.41 4.816-1.227 1.43-0.816 2.555-1.957 3.375-3.418 0.817-1.461 1.223-3.121 1.223-4.984s-0.406-3.527-1.223-4.988c-0.82-1.461-1.945-2.602-3.375-3.418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.465 77.176-9.629-11.824-4.043 4.21v7.614h-6.922v-30.098h6.922v14.059l13.328-14.059h7.738l-12.468 13.414 13.199 16.684zm-27.512-7.074c-1.433 2.363-3.398 4.222-5.891 5.566-2.492 1.348-5.3 2.023-8.425 2.023s-5.938-0.675-8.449-2.023c-2.508-1.344-4.469-3.203-5.887-5.566-1.422-2.364-2.129-5.024-2.129-7.973 0-2.953 0.707-5.613 2.129-7.977 1.418-2.363 3.379-4.218 5.887-5.566 2.511-1.348 5.324-2.02 8.449-2.02s5.933 0.672 8.425 2.02c2.493 1.348 4.458 3.203 5.891 5.566 1.434 2.364 2.149 5.024 2.149 7.977 0 2.949-0.715 5.609-2.149 7.973m2.465-70.102c-34.387 0-62.527 27.844-62.418 61.762 0.039 11.176 3.016 21.633 8.219 30.636 5.625 9.766 13.863 17.84 23.789 23.309 9.066 5.004 19.543 7.836 30.726 7.805 10.871-0.035 21.067-2.785 29.922-7.617 9.926-5.407 18.18-13.418 23.844-23.122 5.336-9.136 8.375-19.769 8.363-31.148-0.051-34.129-27.91-61.621-62.445-61.625"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverallGreen);
export default __webpack_public_path__ + "static/media/overall_green.6ebdff1cbccb8728f39eee44475f577b.svg";
export { ForwardRef as ReactComponent };